import { z } from 'zod';
import { FlowProducedType } from '../flowRun/producedType.js';
/**
 * The fixture data a test flow run reads instead of calling an EHR: one record per kind of data,
 * held against the EHR information the test patient belongs to.
 *
 * The data itself has no shape here. What a record holds is decided by its `dataType`, and the
 * blocks that read it validate their own kind.
 */
const FlowTestPatientDataPayloadSchema = z.looseObject({});
/** Query parameters `GET /test-patients` accepts. */
export const FlowTestPatientDataListQuerySchema = z.object({
    ehrInformationId: z.uuid().describe('Return only records of this test patient.').optional(),
    dataType: z
        .enum(FlowProducedType)
        .describe('Return only records of this kind, such as Patient or Appointment.')
        .optional(),
});
/** Path parameters the endpoints addressing one record by its own id accept. */
export const FlowTestPatientDataIdParamsSchema = z.object({
    id: z.uuid().describe('The test patient data record.'),
});
/**
 * Path parameters the endpoints addressing a record by what it holds accept.
 *
 * A test patient carries at most one record of each kind, so the pair identifies it as well as an
 * id does, and the callers that write fixtures know the pair rather than the id.
 */
export const FlowTestPatientDataKeyParamsSchema = z.object({
    ehrInformationId: z.uuid().describe('The test patient.'),
    dataType: z.enum(FlowProducedType).describe('The kind of data the record holds.'),
});
/** Path parameters `GET /test-patients/{ehrInformationId}` accepts. */
export const FlowTestPatientParamsSchema = FlowTestPatientDataKeyParamsSchema.omit({
    dataType: true,
});
/** Body `POST /test-patients` accepts. */
export const FlowTestPatientDataCreateBodySchema = z.object({
    ehrInformationId: z.uuid().describe('Test patient the record belongs to.'),
    dataType: z.enum(FlowProducedType).describe('The kind of data the record holds.'),
    data: FlowTestPatientDataPayloadSchema.describe('The fixture itself.'),
});
/**
 * Body `POST /test-patients/{ehrInformationId}/{dataType}` accepts: the fixture on its own,
 * with the record it belongs to named by the path.
 *
 * Unlike the create body's `data`, this is not held to being an object — the endpoint has always
 * stored whatever JSON it was handed.
 */
export const FlowTestPatientDataPayloadBodySchema = z.unknown().optional();
/** Body `PATCH /test-patients/{id}` accepts. */
export const FlowTestPatientDataUpdateBodySchema = FlowTestPatientDataCreateBodySchema.partial();
//# sourceMappingURL=testPatientData.js.map